module.exports = __webpack_public_path__ + "officialStatic/img/ap-detailList13.b47cc38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/ap-detailList13.png
// module id = Zz4W
// module chunks = 0